/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Nav_P_AutopilotInputs */

const en_mk_nav_p_autopilot = /** @type {(inputs: Mk_Nav_P_AutopilotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Routines`)
};

const id_mk_nav_p_autopilot = /** @type {(inputs: Mk_Nav_P_AutopilotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rutinitas`)
};

/**
* | output |
* | --- |
* | "Routines" |
*
* @param {Mk_Nav_P_AutopilotInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_nav_p_autopilot = /** @type {((inputs?: Mk_Nav_P_AutopilotInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Nav_P_AutopilotInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_nav_p_autopilot(inputs)
	return en_mk_nav_p_autopilot(inputs)
});